import { ADDREMINDER_SUCCESS, ADDREMINDER_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const addRemindertReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADDREMINDER_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case ADDREMINDER_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default addRemindertReducer;
